import USA from './USA';

export default USA;
